import { FaqService } from './../../services/faq.service';
import { Component, OnInit, Injector } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Faq } from 'server/entity/faq';
import { isNullOrEmpty, getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { SearchFaqParams } from 'src/app/core/models/faq/search-faq-params';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.ViewFAQSearch;

  allFaqList: Faq[] = [];
  faqList: Faq[] = [];
  searchForm: FormGroup;
  facilityOptions: LaasOption[] = [];
  currentLang: string = this.laasSetting.language;

  constructor(
    injector: Injector,
    private dropdownOptionsService: DropdownOptionsService,
    private faqService: FaqService,
    private fb: FormBuilder
  ) {
    super(injector);

    this.searchForm = this.fb.group({
      facility: '',
      keyword: '',
      tenantList: []
    });

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({
          label: x.optionDesc,
          value: x.optionCode
        }));
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    const searchParam: SearchFaqParams = {
      facility: [],
      keyword: '',
      isActivated: 1,
      tenantList: []
    };

    if (this.userProfile.userType == "Tenant") {
      searchParam.tenantList = this.getUserDataScope().authTenantList;
    }

    searchParam.tenantList.push('ALL');

    const distinctArray = searchParam.tenantList.filter((n, i) => searchParam.tenantList.indexOf(n) === i);
    this.searchForm.controls.tenantList.setValue(distinctArray);
    this.faqService.searchFaq(searchParam).subscribe({
      next: (result: Faq[]) => {
        this.allFaqList = result;
        this.faqList = this.allFaqList;
      }
    });


  }

  searchBtnClick(event: any): void {
    const keyword = this.searchForm.value.keyword;
    this.faqList = this.allFaqList.filter(x =>
        x.question?.toLowerCase().includes(keyword.toLowerCase()) || x.answer?.toLowerCase().includes(keyword.toLowerCase()));
  }

  filterByFacility(event: any): void {
    const searchParam: SearchFaqParams = {
      facility: this.searchForm.value.facility,
      keyword: '',
      isActivated: 1,
      tenantList: this.searchForm.value.tenantList
    };



    this.faqService.searchFaq(searchParam).subscribe({
      next: (result: Faq[]) => {
        this.allFaqList = result;
        this.faqList = this.allFaqList;
      }
    });
  }

  getUserDataScope() {
    const dataScopList = getDataScopeByPermission(this.userProfile, PermissionConstants.ViewFAQSearch);
    const authTenantList = dataScopList.map((x:any) =>{ return x.tenant; }).filter((x:any) => !isNullOrEmpty(x));

    return { authTenantList: authTenantList };
  }
}
